//Built-in libraries
import { XCircleIcon } from '@heroicons/react/24/solid';

//Component Begin
export default function SnackbarFailed({
  message,
  title,
  description,
  toastHandler,
}: {
  message: string;
  title?: string;
  description?: string;
  toastHandler: () => void;
}) {
  return (
    <div className='bg-red-50'>
      <div className='p-4'>
        <div className='flex items-start'>
          <div className='shrink-0'>
            <XCircleIcon className='h-6 w-6 text-red-400' aria-hidden='true' />
          </div>
          <div className='ml-3 w-0 flex-1 pt-0.5'>
            <p className='text-sm font-medium text-gray-900'>{title || 'Failed!'}</p>
            <p className='mt-1 text-sm text-gray-500'>{description || message}</p>
          </div>
          <div className='ml-4 shrink-0 flex'>
            <button className='rounded-md inline-flex text-gray-400 hover:text-gray-500' onClick={toastHandler}>
              <span className='sr-only'>Close</span>
              <XCircleIcon className='h-5 w-5' aria-hidden='true' />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
